import ssoLocale from './en.json'

const en = {
  sso: ssoLocale,
}

export default en
